/**
 * Parses backend DateTime (`Y-m-d H:i:s` without timezone) as UTC
 * and converts to a local Date for display/calculations.
 */
export const parseServerDateTime = (dateString) => {
	if (!dateString) return null;

	const value = String(dateString).trim();

	if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(value)) {
		const date = new Date(value);

		return Number.isNaN(date.getTime()) ? null : date;
	}

	if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
		const date = new Date(`${value}T00:00:00`);

		return Number.isNaN(date.getTime()) ? null : date;
	}

	const normalized = value.includes('T') ? value : value.replace(' ', 'T');
	const date = new Date(`${normalized}Z`);

	return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDateShort = (dateString) => {
	if (!dateString) return '';

	const date = parseServerDateTime(dateString);

	if (!date) return '';

	const dd = String(date.getDate()).padStart(2, '0');
	const mm = String(date.getMonth() + 1).padStart(2, '0');
	const yy = String(date.getFullYear()).slice(-2);
	const hh = String(date.getHours()).padStart(2, '0');
	const min = String(date.getMinutes()).padStart(2, '0');

	return `${dd}.${mm}.${yy} в ${hh}:${min}`;
};

export const formatRemainingUpdateTime = (updateUntil) => {
	if (!updateUntil) return null;

	const until = parseServerDateTime(updateUntil);

	if (!until) return null;

	const diff = until - new Date();

	if (diff <= 0) return null;

	const totalSeconds = Math.floor(diff / 1000);
	const minutes = Math.floor(totalSeconds / 60);
	const seconds = totalSeconds % 60;

	return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
